<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-grid style="height: 100%">
    <ion-row class="ion-align-items-center ion-justify-content-center">
      <ion-card color="light">
        <ion-card-header>
          <ion-item lines="full">
            <ion-label color="primary">¿Deseas canjear tu boleto del día?</ion-label>
          </ion-item>
        </ion-card-header>

        <ion-card-content *ngIf="ticket">
          <p hidden>Zona: 1 Expreso</p>
          <p hidden>Ruta: A</p>
          <p *ngIf="ticket.search.type === 'go'">Desde: {{ ticket.search.stop.name }}</p>
          <p *ngIf="ticket.search.type === 'return'">Hacia: {{ ticket.search.stop.name }}</p>
          <p>Fecha: {{ ticket.search.date | toDatestring: 'date' }}</p>
          <p>Hora: {{ ticket.trip.starts_at | slice: 0:5 }}</p>
          <br />
          <h4>No se cobrará nada a tu cuenta.</h4>
          <h4>Perderás tu boleto de suscripción.</h4>
          <h4>El boleto lo encontrarás en "Mis boletos".</h4>
        </ion-card-content>
      </ion-card>
      <ion-button shape="round" color="primary" expand="block" (click)="pay()">Aceptar</ion-button>
      <ion-button shape="round" color="primary" expand="block" (click)="closeModal()">Cancelar</ion-button>
    </ion-row>
  </ion-grid>
</ion-content>
